import { FC, MouseEventHandler } from 'react';

type Props = {
  message: string;
  retry?: boolean;
  retryHandler?: MouseEventHandler<HTMLButtonElement>;
};
const ErrorNotification: FC<Props> = ({ message, retry = false, retryHandler }) => {
  return (
    <div className='text-center'>
      <i className='bi bi-exclamation-triangle fs-1 fw-bolder text-danger'></i>
      <p className='fs-5 mt-2 mb-2 fw-bolder text-muted'>{message}</p>
      {retry && (
        <button className='btn btn-light-primary btn-sm' onClick={retryHandler}>
          Retry
        </button>
      )}
    </div>
  );
};

export default ErrorNotification;
